import * as Yup from "yup";

export const DrawerConstants = {
  PLACEMENT: "right",
  TITLE: "Add Material",
  WIDTH: "50rem",
};

export const FormFieldNames = {
  CATEGORY: "materialCategory",
  SUB_CATEGORY: "materialType",
  MATERIAL_NAME: "materialName",
  MATERIAL_PRICE: "materialPrice",
  TESTING_STATUS: "testingStatus",
  WASHED_STATUS: "washedStatus",
  MATERIAL_TAX: "materialTax",
  SUPPLY_STATUS: "supplyStatus",
  DESCRIPTION: "materialDescription",
  NEW_MATERIAL: "newMaterialName",
};

export const addMaterialFromValidation = Yup.object().shape({
  materialCategory: Yup.string().required("Please choose material category"),
  materialType: Yup.string().required("Please choose material type"),
  materialName: Yup.string().required("Please choose material"),
  materialPrice: Yup.string().required("Please enter material price"),
  materialTax: Yup.string().required("Please choose tax status"),
});
